import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../../Store';
import ModulePatternDesignServiceSettings, { Props } from '../_components/ModulePatternDesignServiceSettings';
import { ModuleOnValueUpdate, ModuleOnMultipleValueUpdate } from '../../_actions/ModuleActions';
import { GetPatternColors } from '@af-common/PatternDesignService/_actions/PatternActions';
import { OnModuleRemove } from '../../../ModuleList/_actions/ModuleListActions';

const mapStateToProps = (store:Store, props:Props) => ({
	source: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'source']),
	categoryId: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'categoryId']),
	color_replacements: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'color_replacements']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onSourceChange: (source:string, category:string) => {
		dispatch(ModuleOnMultipleValueUpdate(props.moduleId, {
			'source': source,
			'categoryId': category
		}));
	},
	onThumbnailChange: (thumbnail:string) => dispatch(ModuleOnValueUpdate(props.moduleId, 'thumbnail', thumbnail)),
	onColorsChange: (colors:Array<string>) => dispatch(ModuleOnMultipleValueUpdate(props.moduleId, {
		'colors': colors,
		'color_replacements': colors
	})),
	onColorReplacementsChange: (colors:Array<string>) => dispatch(ModuleOnMultipleValueUpdate(props.moduleId, {
		'color_replacements': colors
	})),
	getColors: (id:string, callback:Function) => dispatch(GetPatternColors(id, callback)),
	removeModule: (id:string) => dispatch(OnModuleRemove(props.moduleId))
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModulePatternDesignServiceSettings);